// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALBUM = "Naozaj chce\u0161 zmaza\u0165 album?";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_ARTICLE = "Naozaj chce\u0161 zmaza\u0165 \u010dl\u00e1nok?";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_SHARE = "Naozaj chce\u0161 zmaza\u0165 zdie\u013ean\u00fd pr\u00edspevok?";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_SHORT_MESSAGE = "Naozaj chce\u0161 zmaza\u0165 kr\u00e1tku spr\u00e1vu?";
export const ERROR_PLEASE_RELOAD = "Stala sa chyba, sk\u00fas pros\u00edm znova na\u010d\u00edta\u0165 str\u00e1nku.";
